/* 期間限定キャンペーンの案内（snippets/vm-campaign.liquid）。
   [data-vm-campaign] を期間中だけ表示し、帯（bar）があれば上部の帯を画面の最上部に固定する。
   確認用：URL に ?vm_campaign_now=2026-10-16T12:00:00%2B09:00 を付けると、そのタブではその時刻として扱う（off で解除）。
   ただし実際の終了時刻を過ぎたあとは、何を指定しても表示しない。 */
(function () {
  if (window.__vmCampaign) return;
  window.__vmCampaign = true;

  var KEY = 'vmCampaignNow';
  var MEASUREMENT_ID = 'G-T1QGCYK068';

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(location.search);
    return m ? decodeURIComponent(m[1].replace(/\+/g, '%2B')) : null;
  }

  var realNow = Date.now();
  var forced = param('vm_campaign_now');
  try {
    if (forced === 'off') sessionStorage.removeItem(KEY);
    else if (forced) sessionStorage.setItem(KEY, forced);
    forced = sessionStorage.getItem(KEY);
  } catch (e) {}
  var now = forced ? Date.parse(forced) : realNow;
  if (isNaN(now)) now = realNow;

  function gtagProxy() {
    if (typeof window.gtag === 'function') return window.gtag.apply(window, arguments);
    if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(arguments);
  }

  function hideAll() {
    var els = document.querySelectorAll('[data-vm-campaign]');
    for (var i = 0; i < els.length; i++) els[i].hidden = true;
    document.documentElement.classList.remove('vm-campaign-on');
  }

  function fixBar(el) {
    var bar = el.closest('.infobar');
    if (!bar) return;
    var root = document.documentElement;
    function setHeight() { root.style.setProperty('--vm-campaign-bar-h', bar.offsetHeight + 'px'); }
    root.classList.add('vm-campaign-on');
    setHeight();
    window.addEventListener('resize', setHeight);
  }

  function init() {
    var els = document.querySelectorAll('[data-vm-campaign]');
    var end = null;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var s = Date.parse(el.getAttribute('data-start'));
      var e = Date.parse(el.getAttribute('data-end'));
      if (isNaN(s) || isNaN(e)) continue;
      var on = now >= s && now < e && realNow < e;
      el.hidden = !on;
      if (!on) continue;
      if (el.getAttribute('data-vm-campaign') === 'bar') fixBar(el);
      end = end === null ? e : Math.min(end, e);
    }
    // ページを開いたまま終了時刻を過ぎたら隠す
    if (end !== null) {
      var left = Math.min(end - now, end - realNow);
      if (left > 0 && left < 2147483647) setTimeout(hideAll, left);
    }
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest && ev.target.closest('[data-vm-campaign-click]');
    if (!a) return;
    try {
      gtagProxy('event', 'vm_campaign_click', {
        send_to: MEASUREMENT_ID,
        vm_value: a.getAttribute('data-vm-campaign-click'),
        transport_type: 'beacon'
      });
    } catch (e) {}
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
